// extracted by mini-css-extract-plugin
module.exports = {"outer":"_2sUQD","heading":"_1-2Jq","stepsWrapper":"_2IYWU","steps":"_1QVx6","stepsDetail":"_2jGx4"};